<template>
  <div>
    <el-button
      style="margin-bottom: 20px"
      type="primary"
      @click="add(null)"
      v-if="hasAuth('sys:swp:add')"
      >添加
    </el-button>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column
        align="center"
        label="标题"
        prop="title"
      ></el-table-column>
      <el-table-column align="center" label="副标题" prop="viceTitle">
        <template slot-scope="scope">
          <div class="two-line-ellipsis">{{ scope.row.viceTitle }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="排序" prop="sort" width="120">
      </el-table-column>
      <el-table-column align="center" label="是否推荐" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isRecommend == 1" size="small" type="success"
            >推荐
          </el-tag>
          <el-tag v-if="scope.row.isRecommend == 0" size="small" type="danger">
            不推荐
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="封面" prop="cover" width="120">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.cover"
            style="width: 40px; height: 40px"
            :src="scope.row.cover"
            :preview-src-list="scope.row.cover.split(',')"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        width="160"
        align="center"
        label="创建时间"
        prop="createTime"
      ></el-table-column>
      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="200"
      >
        <template slot-scope="scope">
          <el-button plain type="primary" @click="add(scope.row)"
            >编辑</el-button
          >
          <el-button plain type="danger" @click="delHandle(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :total="searchForm.total"
    ></el-pagination>
    <el-dialog
      :before-close="handleClose"
      :title="editForm.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="140px"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>
        <el-form-item label="副标题" prop="viceTitle">
          <el-input v-model="editForm.viceTitle"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="是否推荐" prop="isRecommend">
          <el-radio-group v-model="editForm.isRecommend">
            <el-radio :label="1">推荐</el-radio>
            <el-radio :label="0">不推荐 </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封面" prop="cover">
          <VploadImgFour
            :fileData="fileData"
            :fileSize="fileSize"
            :fileType="fileType"
            :limit="1"
            :value="editForm.cover"
            @input="getImgList"
          >
          </VploadImgFour>
        </el-form-item>
        <el-form-item label="内容" prop="content" v-if="dialogVisible">
          <TinymceEditor
            v-model="editForm.content"
            :min-height="192"
            @change="change"
          ></TinymceEditor>
        </el-form-item>

        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="submitForm('editForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import TinymceEditor from "@/components/Tinymce/index";
import VploadImgFour from "../inc/VploadImgFour";
export default {
  name: "article",
  components: {
    TinymceEditor,
    VploadImgFour,
  },
  data() {
    const RowData = {
      content: "",
      title: "",
      sort: 0,
      cover: "",
      viceTitle: "",
      isRecommend: 0,
    };
    return {
      fileData: {
        type: 0,
        fileType: 0,
      },
      fileType: ["png", "jpg", "jpeg"],
      fileSize: 5,
      editForm: JSON.parse(JSON.stringify(RowData)),
      RawData: JSON.parse(JSON.stringify(RowData)),
      tableData: [],
      dialogVisible: false,
      rules: {
        content: [{ required: true, message: "请输入", trigger: "blur" }],
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        cover: [{ required: true, message: "请上传封面", trigger: "blur" }],
        viceTitle: [{ required: true, message: "请输入", trigger: "blur" }],
        isRecommend: [{ required: true, message: "请选择", trigger: "blur" }],
      },
      classifyList: [],
      goodsVisible: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      goodsList: [],
    };
  },
  created() {
    this.getHomePopList();
  },
  methods: {
    getImgList(val) {
      this.editForm.cover = val;
      console.log(this.editForm.cover);
    },
    change(val) {
      this.editForm.describe = val;
    },
    add(event) {
      if (event) {
        this.editForm = JSON.parse(JSON.stringify(event));
      } else {
        this.editForm = this.RawData;
      }
      this.dialogVisible = true;
    },
    handleClose() {
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
    },
    getHomePopList() {
      this.$axios
        .post("/admin/articleDetail/getList", {
          pageNo: this.searchForm.pageNo,
          pageSize: this.searchForm.pageSize,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.searchForm.total = res.data.total;
        });
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getHomePopList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getHomePopList();
    },

    submitForm(formName) {
      console.log(this.editForm.cover);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {
            content: this.editForm.content,
            title: this.editForm.title,
            sort: this.editForm.sort,
            cover: this.editForm.cover,
            viceTitle: this.editForm.viceTitle,
            isRecommend: this.editForm.isRecommend,
          };
          if (this.editForm.id) {
            obj.id = this.editForm.id;
            this.$axios.post("/admin/articleDetail/upd", obj).then((res) => {
              this.handleClose();
              this.getHomePopList();
              this.$message({
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
          } else {
            this.$axios.post("/admin/articleDetail/add", obj).then((res) => {
              this.handleClose();
              this.getHomePopList();
              this.$message({
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
          }
        } else {
          return false;
        }
      });
    },

    delHandle(val) {
      var _this = this;
      this.$confirm("此操作将删除该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/admin/articleDetail/del", {
              id: val,
            })
            .then((res) => {
              _this.getHomePopList();
              _this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
.two-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制显示的行数为2 */
  -webkit-box-orient: vertical;
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
</style>
